export class PropsComponentHelper<T> {
  private stencilElement: HTMLElement;
  private parsedEntity: T;
  private alreadyParsed: boolean = false;

  constructor(stencilElement: HTMLElement) {
    this.stencilElement = stencilElement;
  }

  public getProps = (): T => {
    const dataModel = this.stencilElement.getAttribute('custom-props');

    if (typeof dataModel === 'string') {
      if (!this.alreadyParsed) {
        this.parsedEntity = JSON.parse(dataModel) as T;
      }

      return this.parsedEntity;
    } else {
      throw new Error('Custom Props is null');
    }
  };
}
